import { CommonModule, Location } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from '@app/services';
import { ErrorComponent } from '@app/shared/error/error.component';
import { LoadingComponent } from '@app/shared/loading/loading.component';

@Component({
    selector: 'app-error-page',
    standalone: true,
    imports: [CommonModule, ErrorComponent, LoadingComponent],
    templateUrl: './error-page.component.html'
})
export class ErrorPageComponent {

  isLoading = false;
  fontSize: number = 18;
  showErrorModal: boolean = false;
  errorTitle: string = '功能尚未開放';
  errorMessage: string = '很抱歉，此功能目前尚未開放，請稍後再試。';

  constructor(
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorageService: LocalStorageService
  ) { }

  async ngOnInit() {
    this.isLoading = true;

    if (isPlatformBrowser(this.platformId)) {
      this.fontSize = this.localStorageService.getItem('fontSize', 18);
    }

    this.showErrorModal = true;
    this.isLoading = false;
  }

  onErrorClose() {
    this.showErrorModal = false;
  }

  onBackRequested() {
    this.showErrorModal = false;
    this.location.back();
  }

}
